/* External event for non angularjs modules */
import fsStoryVideoLoader from '../../platformPlayer/fsStoryVideoLoader';
import LazyloadVideo from '../../platformPlayer/LazyloadVideo';
import analytics from '../../analytics/Analytics';
import segmentAnalytics from '../../analytics/SegmentAnalytics';

angular.module('storyApp').factory('storyEvents', ['metaDataFactory', '$log', 'storyScroll', 'storyProperties', function(metaDataFactory, $log, storyScroll, storyProperties) {

    var service = {
        // decoupling service
        onChangeQueue: [],

        isAdsDisabled: false,

        scrollType: null,

        addOnChange: function(callback) {

            if (typeof callback === 'function') {
                this.onChangeQueue.push(callback);
            } else {
                //throw error
            }

            return this;
        },
        runChangeQueue: function(storyIndex, metadata) {

            this.onChangeQueue.map(function(cb) {
                //pass in values from page change
                cb(storyIndex, metadata);
            })

            return this;
        },
        clearChangeQueue: function() {
            this.onChangeQueue = [];

            return this;
        },

        /**
         * @desc  monitor if Dom content in element is fully loaded
         * @param Object element - Dom object
         * @param Function callback - Function to be called after dom content in element is fully loaded
         **/
        monitorElmOnLoad: function(element, callback) {

            var el = element,
                h = el.clientHeight,
                w = el.clientWidth,
                txt = el.innerText,
                html = el.innerHTML;

            /**
             * recursive IIFE (immediately-invoked function expression) function that calls itself every 300ms
             * until dom content in element is fully loaded.
             * As soon as dom content is fully loaded, invoke the callback function
             **/
            (function runCheck() {
                setTimeout(function() {
                    var done = h == el.clientHeight && w == el.clientWidth && txt == el.innerText && html == el.innerHTML;
                    if (done) {
                        callback();
                    } else {
                        h = el.clientHeight;
                        w = el.clientWidth;
                        txt = el.innerText;
                        html = el.innerHTML;
                        runCheck();
                    }

                }, 300);
            })();
        },

        /**
         * @desc  Story Event on story on change
         * @param Number storyIndex - 1: the orignal story, 2: first story on the 3 things, 3: second story on the 3 things and 4: the third (last) story on the 3 things
         * @param Object metaData - meta data for meta tags, ads and analytics
         * @param Boolean onPageload - true or false to determine if onPageChanged is called on pageload or onScroll
         **/
        onPageChanged: function(storyIndex, metaData, onPageload) {

            // remove A/B test property from any stories other than the original
            if(1 !== storyIndex && typeof metaData.analytics.testScorestripPosition !== 'undefined') {
                delete metaData.analytics.testScorestripPosition;
            }

            //only load ads and update analytics on page change triggered by scroll, not on page load since the first story's ad and analytics has been run on page load
            if (!onPageload) {

                //run all on change callback if that is not on page load
                this.runChangeQueue(storyIndex, metaData);

                //change page metaData
                metaDataFactory.onPageChanged(metaData);

                this.setMetadataStorageOnChange(storyIndex - 1, metaData.analytics);

            }

            if (storyIndex > 1) {
                // load videos
                fsStoryVideoLoader.start(storyIndex, 0);
            }

            /**
             * initialize onClick event for lazy-loading the videos on 3things including the main story
             * videos will be rendering and playing when users click on video placeholder images
             */
            LazyloadVideo.addClickListeners(document.querySelectorAll('#story-' + storyIndex + ' .video-placeholder'));

            //for gallery module analytic and refresh ads on images scroll
            window.FsCurrentStory = storyIndex;
        },
        /**
         * @desc Save each article analytic meta data on url change
         *       first index 0 holds first article analytic meta data.
         *       second index of 1 holds second article analytic meta data and so on.
         *       These analytic data will be used on gallery or video pages for analytic service
         * @param i
         * @param meta
         */
        setMetadataStorageOnChange: function(i, meta) {
            // check if the meta data for that article has been set yet. If it is not, set it.
            if (analytics.metadataStorage[i] === undefined) {
                analytics.setMetadataStorage(i, meta);
            }

        },

        init: function() {

            // register analytics callbacks on change
            this.addOnChange(function(storyIndex, metadata) {
                var analyticsObj = metadata.analytics;
                // update story position on page change
                analyticsObj.story_position = storyIndex;
                // send the analytics data to utag
                analytics.utagView(analyticsObj);
            	segmentAnalytics.trackPage(null, {
                    name: analyticsObj.page_name,
                    path: analyticsObj.dom.pathname,
                    url: analyticsObj.dom.url,
                    title: analyticsObj.story_title,
                });
            });

        }
    };

    service.init();

    return service;

}]);